(function () {
  var el = document.getElementById('HmcEmailPopup');
  if (!el) return;
  var KEY = 'hmc_popup_seen';
  var SKEY = 'hmc_popup_session';
  var days = parseInt(el.dataset.days || '14', 10);
  var delay = parseInt(el.dataset.delay || '12', 10) * 1000;
  var path = window.location.pathname;
  // the announcement bar reopens the popup on demand, on every page, even if it was seen or closed before
  function forceOpen() { el.setAttribute('open-state', 'true'); var i = el.querySelector('input[type=email]'); if (i) i.focus(); }
  function closeNow() { el.setAttribute('open-state', 'false'); }
  var bar = document.querySelector('.announcement-bar');
  if (bar) {
    bar.classList.add('hmc-announce--clickable');
    bar.setAttribute('role', 'button');
    bar.setAttribute('tabindex', '0');
    bar.setAttribute('aria-haspopup', 'dialog');
    bar.addEventListener('click', function (e) { if (e.target.closest('a')) return; e.preventDefault(); forceOpen(); });
    bar.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); forceOpen(); } });
  }
  var cl = el.querySelector('[data-hmc-popup-close]');
  if (cl) cl.addEventListener('click', closeNow);
  el.addEventListener('click', function (e) { if (e.target === el) closeNow(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNow(); });
  // never over cart, checkout, account or after a successful signup (customer form returns ?contact_posted=true)
  if (/^\/(cart|checkout|account)/.test(path) || /\/products\//.test(path)) return;
  var posted = /contact_posted=true/.test(window.location.search);
  function seenSession() { try { return sessionStorage.getItem(SKEY) === '1'; } catch (e) { return false; } }
  function markSession() { try { sessionStorage.setItem(SKEY, '1'); } catch (e) {} }
  function seen() { try { var t = parseInt(localStorage.getItem(KEY) || '0', 10); return t && Date.now() - t < days * 864e5; } catch (e) { return false; } }
  function mark() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
  var shown = false;
  function open() { if (shown) return; shown = true; markSession(); el.setAttribute('open-state', 'true'); var i = el.querySelector('input[type=email]'); if (i) i.focus(); }
  function close() { el.setAttribute('open-state', 'false'); mark(); }
  if (posted) { mark(); return; }
  el.querySelector('[data-hmc-popup-close]').addEventListener('click', close);
  el.addEventListener('click', function (e) { if (e.target === el) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  el.querySelector('form').addEventListener('submit', mark);
  if (el.dataset.preview === 'true') return;
  if (seen() || seenSession()) return;
  var armed = false;
  setTimeout(function () { armed = true; }, 3000);
  setTimeout(open, delay);
  document.addEventListener('mouseout', function (e) { if (armed && !e.relatedTarget && e.clientY <= 0) open(); });
})();
